import React, { useEffect } from 'react';
import { PropTypes } from 'prop-types';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';

import LocalisedMessage from 'components/Common/LocalisedMessage';

import ErrorPage from 'components/Errors/ErrorPage';

import { timeOutSession } from 'actions/app';

const AlreadyLoggedIn = ({ intl, dispatch, titleTextId }) => {
  useEffect(() => {
    dispatch(timeOutSession());
  }, []);

  return (
    <ErrorPage
      title="Already Logged In"
      titleTextId={ titleTextId }
      type="server"
    >
      <LocalisedMessage id="alreadyloggedin.content" />
    </ErrorPage>
  );
};

AlreadyLoggedIn.propTypes = {
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired,
    messages: PropTypes.shape().isRequired
  }).isRequired,
  dispatch: PropTypes.func.isRequired,
  titleTextId: PropTypes.string
};

AlreadyLoggedIn.defaultProps = {
  titleTextId: 'alreadyloggedin.title',
};

const mapDispatchToProps = dispatch => ({ dispatch });

export default injectIntl(connect(
  null,
  mapDispatchToProps
)(AlreadyLoggedIn));
